
import React, { useEffect, useState, useRef } from 'react';
import '../../css/AsesoresLanding.css';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { createAsesores, seleccionarCanal } from "../../Services/asesores.services"
import { enviarSms, enviarSmsToken } from "../../Services/sms.services"
import Swal from 'sweetalert2';
import { Carousel } from 'react-bootstrap';
import TokenModal from '../TokenModal/ModalToken';
// import ModalValidacionExitosa from '../TokenModal/ModalValidacionExitosa';
import TerminosDelSorteo from '../TokenModal/TerminosDelSorteo';
import ModalConfirmacionExitosa from '../TokenModal/ModalConfirmacionExitosa';
import Footer from '../../components/Footer/footer';
import {CONSTANTES} from "../../config/constantaes";
import Operador from '../../components/Operador/operador';
import { useContext } from "react";
import { UtmContext } from "../../context/UtmContext";
  

const AsesoresLanding = () => {
    
     const [canales, setCanales] = useState([]);
     const [loading, setLoading] = useState(false);
     const [errorCorreo, setErrorCorreo] = useState(null);
     const [, setError] = useState(null);
     const [, setBackendError] = useState(null);
     const { executeRecaptcha } = useGoogleReCaptcha();
     const [recaptchaToken, setRecaptchaToken] = useState(null);
     const [submitted, setSubmitted] = useState(false);
     const [tokenEnviado, setTokenEnviado] = useState(false);
     const [index, setIndex] = useState(0);
     const sendingRef = useRef(false);
     const consentimiento2Ref = useRef(null);
     const [showTokenModal, setShowTokenModal] = useState(false);
     const [tokenValidado, setTokenValidado] = useState(false);
     const [showModalConfirmacionExitosa, setShowModalConfirmacionExitosa] = useState(false);
     const [textoActual, setTextoActual] = useState("");
     const [tokenEncriptado, setTokenEncriptado] = useState("");
     const [celular, setCelular] = useState("");
     const [, setMostrarMensajePolitica] = useState(false);
     const [consentimiento1Habilitado, setConsentimiento1Habilitado] = useState(false);
     const [mostrarConsentimiento2, setMostrarConsentimiento2] = useState(false);
     const [consentimiento2Habilitado, setConsentimiento2Habilitado] = useState(false);
     const canalTimeoutRef = useRef(null);
     const utmData = useContext(UtmContext);
     
     function generarCodigoCliente(dni) {
          if (!dni || dni.length !== 8) return "";
          return `CL-${dni}`;
      }

    useEffect(() => {
        const cargarCanales = async () => {
          try {
            setLoading(true);
            const response = await seleccionarCanal();
            if (response && response.data) {
              setCanales(response.data); // Usa el array de canales directamente
            }
          } catch (err) {
            setError("Error al conectar con el servicio.");
          } finally {
            setLoading(false);
          }
        };
          cargarCanales();
          limpiarFormulario();
          sessionStorage.removeItem("tokenValidado");
          setTokenValidado(false); // Asegura que el botón quede deshabilitado al inicio
    },[]);
    
     const [formData, setFormData] = useState({
          dni: '',
          telefono: '',
          correo: '',
          operadorId: '',
          codigoCliente:'',
          consentimientoCliente1: 0,
          consentimientoCliente2: 0,
          codigoAsesor: '',
          canalId: '',
          consentimiento1: 0,
          consentimiento2: 0,
          captcha:''
      });
    
      useEffect(() => {
              if (formData.dni?.length === 8) {
                const codigo = `CL-${formData.dni}`;
      
                setFormData(prev => {
                  if (prev.codigoCliente === codigo) return prev; // evita renders innecesarios
      
                  return {
                    ...prev,
                    codigoCliente: codigo
                  };
                });
              }
       }, [formData.dni]);
       
  const handleContinuarRegistro = async () => {

  if (loading) return; // 🔒 evita doble ejecución

  if (!executeRecaptcha) {
    await Swal.fire({
      title: 'Error',
      text: 'Captcha no disponible.',
      icon: 'error'
    });
    return;
  }

  if (!formData.codigoCliente) {
    await Swal.fire({
      title: 'Error',
      text: 'No se pudo generar el código del cliente.',
      icon: 'error'
    });
    return;
  }

  try {
    setLoading(true); // 🔥 SOLO aquí

    const captchaToken = await executeRecaptcha('registro');

    const asesoresPayload = {
      ...formData,
      operadorId: formData.operadorId,
      consentimientoCliente1: 0,
      consentimientoCliente2: 1,
      consentimiento1: formData.consentimiento1 ? 1 : 0,
      consentimiento2: formData.consentimiento2 ? 1 : 0,
      captcha: captchaToken,

      URL_UTM: window.location.href,
      UTM_SOURCE: "ASESOR",
      UTM_MEDIUM: formData.canalId?.toString() || "",
      UTM_CAMPAIGN: formData.codigoAsesor || "",
      UTM_TERM: "",
      UTM_CONTENT: formData.operadorId?.toString() || ""
    };

    const response = await createAsesores(asesoresPayload);

    if (!response) {
      await Swal.fire({
        title: 'Error',
        text: 'No se recibió respuesta del servidor.',
        icon: 'error'
      });
      return;
    }

    if (!response.success) {
      await Swal.fire({
        title: 'Oops..',
        text: response.message || "Ocurrió un error.",
        icon: 'error'
      });

      limpiarFormulario();
      return;
    }

    // ÉXITO
    setShowModalConfirmacionExitosa(true);

    try {
      await enviarSms({
        cellPhone: formData.telefono,
        message: "",
        senderId: "ALFIN",
        email: formData.correo,
        operadorId: formData.operadorId
      });
    } catch (e) {
      console.error("Error enviando confirmación:", e);
    }

    setTimeout(() => limpiarFormulario(), 300);

  } catch (error) {

    const errorMessage =
      error?.response?.data?.message ||
      'Algo salió mal. Intenta nuevamente más tarde.';

    await Swal.fire({
      title: 'Oops..',
      text: errorMessage,
      icon: 'error'
    });

    limpiarFormulario();

  } finally {
    setLoading(false); 
  }
};
    const handleSelect = (selectedIndex, e) => {
          setIndex(selectedIndex);
        };

    const validarCorreo = (email) => {
      email = email.trim().toLowerCase();
      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

        if (!emailRegex.test(email)) {
          return "Ingrese un correo válido.";
        }
        if (email.includes("..")) {
          return "El correo no puede contener puntos consecutivos.";
        }
        return null;
    };    
    
    const handleInputChange = (e) => {
      const { name, value, type, checked } = e.target;

      if (name === "correo") {
         const error = validarCorreo(value);
         setErrorCorreo(error);
       }

       setFormData(prev => ({
         ...prev,
         [name]:
         name === "operadorId"
         ? (value ? parseInt(value) : "")
         : (type === 'checkbox' ? checked : value)
       }));
    };

    const handleCorreoChange = (e) => {
      const { value } = e.target;

      setFormData(prev => ({ ...prev, correo: value }));
           
      const error = validarCorreo(value);
      setErrorCorreo(error);

      if (!error) {
        setMostrarMensajePolitica(true);
        setConsentimiento1Habilitado(false); // Lo desactivamos temporalmente

        setTimeout(() => {
          setMostrarMensajePolitica(false);
        }, 3000);
        } else {
          setMostrarMensajePolitica(false);
          setConsentimiento1Habilitado(false);
        }
    };

    const limpiarFormulario = () => {
          setFormData({
            dni: '',
            telefono: '',
            correo: '',
            operadorId:'',
            codigoCliente: generarCodigoCliente(),
            consentimiento1: 0,
            consentimiento2: 0,
            codigoAsesor: '',
            canalId: '',
          });
          setErrorCorreo(null); 
          setSubmitted(false);
          setTokenValidado(false);

          setConsentimiento1Habilitado(false);
          setMostrarConsentimiento2(false);

          sessionStorage.removeItem("formAsesor");
          sessionStorage.removeItem("tokenValidado");
    };
   
   // const [showTokenModal, setShowTokenModal] = useState(false);//TokenModal
    const handleSubmit = async (e) => {
        e.preventDefault();        
        setError(null);
        setSubmitted(true);

        if (!formData.consentimiento2) {
          Swal.fire({
            title: 'Consentimiento requerido',
            text: 'Debes aceptar la política de privacidad para continuar.',
            icon: 'info'
          });
          return;
        }
        try {
          setLoading(true);

          //PASO 1: ENVIAR OTP
          await enviarSmsToken({
            operadorId: formData.operadorId,
            celular: formData.telefono,
            correo: formData.correo,
            nombre: formData.dni
          });

          //PASO 2: ABRIR MODAL TOKEN
          setShowTokenModal(true);

        } catch (error) {
          Swal.fire({
            title: 'Error',
            text: 'No se pudo enviar el código.',
            icon: 'error'
          });
        } finally {
          setLoading(false);
        }
    };
    
    //Validación del token
    // const handleTokenValidado = (validado) => {
    //   if (validado) {
    //     setShowTokenModal(false);
    //     setShowModalValidacionExitosa(true);
    //   }
    // };
    //Validación del token
    const handleTokenValidado = async (validado) => {
      if (validado) {
        setShowTokenModal(false);
       

        // flujo directo
        await handleContinuarRegistro();
      }
    };

    const cerrarModal = () => {
      setShowModalConfirmacionExitosa(false);
    };
const OPERADOR_BITEL = 3;
const esBitel = formData.operadorId === OPERADOR_BITEL;

const habilitado =
  formData.dni?.length === 8 &&
  formData.telefono?.length === 9 &&
  formData.correo &&
  !errorCorreo &&
  formData.operadorId &&
  formData.codigoAsesor &&
  formData.canalId &&
  formData.consentimiento2;

  return (
    <div className="container-fluid p-0 asesores-landing">
      <header className="custom-header py-3 px-4 d-flex align-items-center">
          <a
            href="https://www.alfinbanco.pe/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://i0.wp.com/www.alfincontacto.pe/wp-content/uploads/2024/06/ALFIN-CONTACTO.png?w=920&ssl=1"
              alt="Alfin Banco"
              height="80px"
            />
          </a>
      </header>
      <div className="custom-div">
        <span role="img" aria-label="gift">🎁</span>
        <span style={{ marginLeft: '8px' }}>Próximo sorteo: <strong>{CONSTANTES.FECHA_CAMPANIA}</strong></span>
      </div>
      <div className="row flex-column flex-md-row main-content">
        <div className='col-md-6 d-flex flex-column align-items-center mb-2 mb-md-0 custom-background movil-contenedor' style={{ position: 'relative' }}>
          <Carousel activeIndex={index}
              onSelect={handleSelect}
              controls={false}
              indicators={false}
              fade
              interval={2000}
              className="carousel-asesores">
                  {[].map(num => (
                                      <Carousel.Item key={num} style={{  height: '100%' }}>
                                        <img 
                                          className="imagen-carousel"
                                          src={require(`../../assets/img/${num}-min.png`)}
                                          alt={`Banner ${num}`}
                                        />
                                      </Carousel.Item>
                                  ))}
          </Carousel>
        </div>
        <div className="col-md-6 h-100">
          <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white h-100 d-flex flex-column justify-content-between" style={{minHeight: '650px'}}>
           <div className='mb-1'>
            <h1 className="tituloAsesores">
              <strong>Asiste al cliente en su registro</strong>
            </h1>
            <p className="subtituloAsesores">Regístralo en pocos pasos y recolectemos sus datos con consentimiento</p>
            
            <div className="row g-3">
              <div className="col-12">
                <h2 className="encabezadoClientes">
                  Datos del Cliente
                </h2>
              </div>

              <div className='col-12'>
                <input
                  name="dni"
                  type="text"
                  className="form-control input-movil tamano-input"
                  placeholder="Tu número de DNI aquí"
                  pattern="\d{8}" title="Debe contener exactamente 8 dígitos"
                  maxLength="8"  required
                  value={formData.dni}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, '');
                    setFormData({ ...formData, dni: onlyNums });
                  }}              
              />
              </div>
              <div className='col-12 col-md-6'>
                <Operador
                    name="operadorId"
                    className="form-select input-movil tamano-input"
                    value={formData.operadorId}
                    onChange={handleInputChange}
                    disabled={formData.dni.length !== 8}
                />
              </div>
              <div className='col-12 col-md-6'>
                <input  name="telefono"  type="text"
                  className="form-control input-movil tamano-input"
                  placeholder="Tu número de celular aquí"
                  pattern="\d{9}"  title="Debe contener exactamente 9 dígitos"
                  maxLength="9"
                  required
                  value={formData.telefono}
                  disabled={!formData.operadorId}
                  onChange={(e) => {
                      const onlyNums = e.target.value.replace(/\D/g, '');
                      
                      setFormData({ ...formData, telefono: onlyNums });
                    }}
                  /> 
              </div>
              {submitted && formData.telefono.trim() === '' && (
                <small style={{ color: '#ff3c00' }}>Este dato es necesario para continuar.</small>
              )}
              {formData.telefono.length > 0 && formData.telefono.length !== 9 && (
                <small style={{ color: '#ff3c00' }}>El celular debe tener 9 dígitos.</small>
              )}
              {formData.telefono.length === 9 && !formData.telefono.startsWith('9') && (
                <small style={{ color: '#ff3c00' }}>
                 Celular no consistente (debe empezar con 9).
                </small>
              )}
              <div className='col-12'>
                <input name="correo"
                  type="email" 
                  className="form-control input-correo-movil tamano-correo"
                  placeholder="Tu correo electrónico aquí"
                  value={formData.correo}
                  title="Ingresa un correo válido" required
                  onChange={handleCorreoChange}
                  disabled={formData.telefono.length !== 9}
                />
                {errorCorreo && (
                  <small style={{ color: '#ff3c00' }}>{errorCorreo}</small>
                )}

                 {/*MENSAJE SOLO PARA BITEL */}
                {esBitel && (
                  <div className="mensaje-bitel">
                    Recuerda, el cliente debe mencionar un <strong>correo válido</strong>, ya que le enviaremos un código de 4 dígitos para <strong>validar su identidad</strong>.
                  </div>
                )}
              </div>
            </div>

            <div className="row g-3 mt-4">
              <div className="col-12">
                <h2 className="encabezadoClientes">
                  Datos del asesor
                </h2>
              </div>
              <div className='col-12 col-md-6'>
                <input  name="codigoAsesor"  type="text"
                className="form-control input-movil tamano-input"
                placeholder="Tu codigo asesor aquí"
                title="Ingresa el código del asesor"
                value={formData.codigoAsesor}  
                required
                maxLength="10"
                disabled={!(formData.correo && !errorCorreo)}
                onChange={(e) => {
                  const alfanumerico = e.target.value.replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);
                  setFormData({ ...formData, codigoAsesor: alfanumerico });
                }}
              />
              </div>
              <div className='col-12 col-md-6'>
                <select  name="canalId"  
                  className="form-select input-movil tamano-input"
                  value={formData.canalId}
                  disabled={!formData.codigoAsesor}
                  onChange={handleInputChange}
                  required
                >
                <option value="" disabled>Canal de atención</option>
                {canales.map((canal) => (
                        <option key={canal.canalId} value={canal.canalId}>
                          {canal.descripcionCanal}
                          </option>
                ))} 
                </select>
              </div>
              <div className="col-12">
                <div className="form-check mb-2">
                  <input className="form-check-input"
                    type="checkbox"
                    name="consentimiento2"
                    id="promoCheck"
                    checked={formData.consentimiento2}
                    onChange={handleInputChange}
                    // disabled={!consentimiento2Habilitado}
                    disabled={!formData.canalId} 
                  />
                  <label className="form-check-label" htmlFor="promoCheck" style={{ display: 'block' }}>
                    <span style={{ color: '#6e7881' }}>He leído y otorgo mi </span>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.alfinbanco.pe/promociones-con-fines-comerciales"
                      style={{ color: '#f44336' }}
                    >
                      Consentimiento para el Tratamiento de mis datos personales con finalidades comerciales
                    </a>{' '}
                    <span style={{ color: '#660099', fontWeight: 700 }}>
                      *Obligatorio
                    </span>
                  </label>
                  
                </div>
              </div>
              <div className="elementor-button-wrapper">
                  <button
                    type="submit"
                    className={`btn custom-btn d-flex align-items-center gap-2 ${habilitado ? "btn-activo" : "btn-bloqueado"}`}
                    disabled={loading || !habilitado}
                  >
                    {loading ? 'Enviando...' : (
                      <>
                        <svg aria-hidden="true"
                          className="e-font-icon-svg e-fas-file-export"
                          viewBox="0 0 576 512"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20">
                          <path d="M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z" fill="currentColor" />
                        </svg>
                        <span className="elementor-button-text">Registrar cliente</span>
                      </>
                    )}
                  </button>
              </div>
            </div>
            <p style={{marginTop: '20px', fontSize: '12px', textAlign: 'center'}}>Conoce como ejercer tus derechos ARCO <a target='_blank' href='https://abancodigital.atlassian.net/servicedesk/customer/portal/57/group/111/create/409'>aqui</a></p>
           </div>
          </form>
          <TokenModal
          show={showTokenModal} 
          onClose={() => setShowTokenModal(false)}
          celular={formData.telefono}
          correo={formData.correo}
          operadorId={formData.operadorId}
          onTokenValidado={handleTokenValidado}
          />
          {/* <ModalValidacionExitosa
             show={showModalValidacionExitosa}
             onContinuar={handleContinuarRegistro}
          /> */}

          {/* Aquí renderizamos el modal de confirmación */}
          <ModalConfirmacionExitosa 
            show={showModalConfirmacionExitosa} 
            onClose={cerrarModal}
          />
          
                
        </div>
      </div>
       <div className='legal-container_ejemplo d-flex flex-column flex-md-row align-items-start align-items-md-center'>
          <div style={{ fontSize: '11px', textAlign: 'justify', color: '#a09ea0', width: '100%'}}>
                <TerminosDelSorteo />
          </div>
        </div>
        
        <Footer/>
    </div>
    
  );
  
};
export default AsesoresLanding;